import React from 'react';
import PropTypes from 'prop-types';
import useTrackLoadTime from './helpers';

const LoaderTracker = ({
  Loader, loadEventName, loadEventProps, ...rest
}) => {
  useTrackLoadTime(loadEventName, loadEventProps);
  return <Loader {...rest} />;
};

LoaderTracker.propTypes = {
  Loader: PropTypes.func.isRequired,
  loadEventName: PropTypes.string,
  loadEventProps: PropTypes.object
};

LoaderTracker.defaultProps = {
  loadEventName: undefined,
  loadEventProps: {}
};

export default LoaderTracker;
